import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
const eventDefinitionsKey = "get-threat-related-event-definitions";
export const eventDefinitionsQuery = (coverageEntity) => {
  var _a;
  const ids = coverageEntity ? [coverageEntity.id, ...(_a = coverageEntity.childrenIds) != null ? _a : []] : [];
  return ids.length > 0 ? `tactics_techniques:${ids.join()}` : "tactics_techniques:*";
};
const fetchPaginated = (query) => fetch(
  "GET",
  qualifyUrl(`/events/definitions/paginated?query=${encodeURIComponent(query)}&page=1&per_page=100000`)
);
const useThreatRelatedEventDefinitions = (coverageEntity) => {
  var _a;
  const query = eventDefinitionsQuery(coverageEntity);
  const { data, isLoading } = useQuery({
    queryKey: [eventDefinitionsKey, query],
    queryFn: () => fetchPaginated(query),
    retry: 2
  });
  const allDefinitions = (_a = data == null ? void 0 : data.elements) != null ? _a : [];
  const notEnabledDefinitions = allDefinitions.filter((d) => d.state === "DISABLED");
  return {
    allDefinitions,
    notEnabledDefinitions,
    loadingDefinitions: isLoading
  };
};
export default useThreatRelatedEventDefinitions;
